// src/components/views/HypeArcadeView.tsx - COMPLETE UI IMPROVED VERSION (FIXED - NO FLOATING ACTIONS)
import React, { useState, useEffect } from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import { 
  ArrowLeft, Search, ShoppingBag, Bell, MessageCircle, 
  Home, Users, Plus, Gamepad2, Dice1, Dice2, Dice3, Dice4, Dice5, Dice6,
  Crown, Sparkles, Zap, Flame, Gift, Coins, Trophy, Award,
  ChevronRight, Star, Clock, TrendingUp, Rocket, Layers,
  Play, Circle, Square, Triangle, Shield, Sword, Wand2,
  Gem, DollarSign, BarChart, Target, Crosshair, Swords,
  Loader2, X, Menu, History, Ticket, ShieldAlert,
  ChevronDown, ArrowRight, Dribbble, User, Banknote, Compass, Palette,
  CreditCard
} from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';
import { useCart } from '../../contexts/CartContext';
import { db } from '../../services/firebase';
import { collection, query, where, onSnapshot, doc, getDoc, getDocs, limit } from 'firebase/firestore';

// 🟢 IMPORT WalletTerminal from wallet folder
import { WalletTerminal } from '../wallet/WalletTerminal';

// 🟢 GAME IMAGES
const gameImages = {
  threadWars: 'https://firebasestorage.googleapis.com/v0/b/scoop-streetwear.firebasestorage.app/o/Games%2FThread%20Wars.png?alt=media&token=e777f688-54d8-4587-be83-61364c58b71f',
  copOrDrop: 'https://firebasestorage.googleapis.com/v0/b/scoop-streetwear.firebasestorage.app/o/Games%2FCop%20Or%20Drop.png?alt=media&token=04d76ea5-d3dc-467c-a034-147a289f0e04',
  mysteryDrop: 'https://firebasestorage.googleapis.com/v0/b/scoop-streetwear.firebasestorage.app/o/Games%2FMystery%20Drop.png?alt=media&token=d2c54244-3260-4c3f-b192-47c094c27733',
  hyce: 'https://firebasestorage.googleapis.com/v0/b/scoop-streetwear.firebasestorage.app/o/Games%2FHyce.png?alt=media&token=3dd8b28c-072c-4ac3-9c11-1c8060e5ae7f',
  crash: 'https://firebasestorage.googleapis.com/v0/b/scoop-streetwear.firebasestorage.app/o/Games%2FHype%20Crash.png?alt=media&token=eebaf492-e844-4ae0-bed8-3de62c89225c',
  sweeper: 'https://firebasestorage.googleapis.com/v0/b/scoop-streetwear.firebasestorage.app/o/Games%2FSweeper.png?alt=media&token=d7f009f6-d509-4529-b1d2-8a35807d5fc4',
  shells: 'https://firebasestorage.googleapis.com/v0/b/scoop-streetwear.firebasestorage.app/o/Games%2FShells.png?alt=media&token=d9b611bf-f00e-4eee-8b5a-87fcf82abbf6',
  stacker: 'https://firebasestorage.googleapis.com/v0/b/scoop-streetwear.firebasestorage.app/o/Games%2Fstack%20scoophype%20(1).png?alt=media&token=978c6a2c-5184-4ad6-9267-77ead0ddbc0d',
  balldrop: 'https://firebasestorage.googleapis.com/v0/b/scoop-streetwear.firebasestorage.app/o/Games%2Fdrop%20scoophype%20(1).png?alt=media&token=6fff6b12-f052-4cd0-a53b-95462fc86890',
  glassbridge: 'https://firebasestorage.googleapis.com/v0/b/scoop-streetwear.firebasestorage.app/o/Games%2Fglass%20scoophype%20(1).png?alt=media&token=7ab8e618-38dc-48ec-9e0e-127aae948b61',
  zwepz: 'https://firebasestorage.googleapis.com/v0/b/scoop-streetwear.firebasestorage.app/o/Games%2Fzweps%20scoophype%20(1).png?alt=media&token=7492248c-35d0-4989-9a5c-fa830c20b3de',
};

// 🟢 PRIZE POOL IMAGES
const prizeImages = {
  merch: 'https://firebasestorage.googleapis.com/v0/b/scoop-streetwear.firebasestorage.app/o/Games%2Fscoopprizes.jpg?alt=media&token=53cb1eca-3057-4093-bb4d-9de7ae05acaa',
  jackpot: 'https://firebasestorage.googleapis.com/v0/b/scoop-streetwear.firebasestorage.app/o/Games%2FScoopjackpot.jpg?alt=media&token=06aeae10-5783-4b37-bc47-21dfdb61b627',
};

// 🟢 PAYMENT METHOD ICONS
const paymentIcons = {
  mastercard: 'https://firebasestorage.googleapis.com/v0/b/scoop-streetwear.firebasestorage.app/o/master-card.png?alt=media&token=6a81e0ed-8d2f-4f9c-95e1-db80fcc34a34',
  applepay: 'https://firebasestorage.googleapis.com/v0/b/scoop-streetwear.firebasestorage.app/o/ApplePayLogo.png?alt=media&token=a3b8ef0b-7755-4598-a6c1-37844db68d91',
  visa: 'https://firebasestorage.googleapis.com/v0/b/scoop-streetwear.firebasestorage.app/o/visa.png?alt=media&token=5b1dac5d-04c1-4210-acdf-26dddf7a143b',
};

// 🟢 GAME DATA
interface Game {
  id: string;
  title: string;
  subtitle: string;
  description: string;
  icon: React.ReactNode;
  bgImage: string;
  route: string;
  color: string;
  category: 'arcade' | 'strategy' | 'social' | 'all';
  players: number;
  prizePool?: string;
  isLive?: boolean;
  isNew?: boolean;
  isHot?: boolean;
}

const GAMES: Game[] = [
  {
    id: 'thread-wars',
    title: 'THREAD WARS',
    subtitle: 'Live Battles',
    description: 'Battle other creators in real-time fashion showdowns.',
    icon: <Swords size={24} />,
    bgImage: gameImages.threadWars,
    route: 'thread-wars',
    color: 'from-red-600 to-orange-500',
    category: 'arcade',
    players: 234,
    isLive: true,
    isHot: true,
  },
  {
    id: 'cop-or-drop',
    title: 'COP OR DROP',
    subtitle: 'Swipe to Rate',
    description: 'Swipe through streetwear pieces and decide: cop it or drop it?',
    icon: <Target size={24} />,
    bgImage: gameImages.copOrDrop,
    route: 'cop-or-drop',
    color: 'from-blue-600 to-purple-500',
    category: 'social',
    players: 156,
    isLive: true,
  },
  {
    id: 'mystery-drop',
    title: 'MYSTERY DROP',
    subtitle: 'Unlock Gear',
    description: 'Pay to open mystery boxes and unlock exclusive streetwear pieces.',
    icon: <Gift size={24} />,
    bgImage: gameImages.mysteryDrop,
    route: 'mystery-drop',
    color: 'from-purple-600 to-pink-500',
    category: 'arcade',
    players: 89,
    prizePool: 'R5,000',
    isHot: true,
  },
  {
    id: 'hyce',
    title: 'HYCE',
    subtitle: 'Dice Game',
    description: 'Roll the dice and test your luck. Double or nothing on every throw.',
    icon: <Dice1 size={24} />,
    bgImage: gameImages.hyce,
    route: 'hyce',
    color: 'from-green-600 to-teal-500',
    category: 'arcade',
    players: 67,
    prizePool: 'R2,500',
  },
  {
    id: 'hype-stacker',
    title: 'HYPE STACKER',
    subtitle: 'Stack & Win CRD',
    description: 'Build your tower of hype. The higher you stack, the more CRD you earn.',
    icon: <Layers size={24} />,
    bgImage: gameImages.stacker,
    route: 'hype-stacker',
    color: 'from-yellow-600 to-orange-500',
    category: 'strategy',
    players: 45,
    prizePool: '1,500 CRD',
  },
  {
    id: 'ball-drop',
    title: 'BALL DROP',
    subtitle: 'Drop & Multiply',
    description: 'Watch the ball drop through the pins and multiply your CRD.',
    icon: <Circle size={24} />,
    bgImage: gameImages.balldrop,
    route: 'ball-drop',
    color: 'from-indigo-600 to-blue-500',
    category: 'arcade',
    players: 78,
    prizePool: '3,200 CRD',
    isLive: true,
  },
  {
    id: 'glass-bridge',
    title: 'GLASS BRIDGE',
    subtitle: 'Cross to Survive',
    description: 'Step carefully across the glass bridge. One wrong step and you fall.',
    icon: <Shield size={24} />,
    bgImage: gameImages.glassbridge,
    route: 'glass-bridge',
    color: 'from-cyan-600 to-blue-500',
    category: 'strategy',
    players: 34,
    prizePool: '4,000 CRD',
  },
  {
    id: 'zwepz',
    title: 'ZWEPZ',
    subtitle: 'Coin Flip Duel',
    description: 'Heads or tails? Challenge other players in a coin flip duel.',
    icon: <Coins size={24} />,
    bgImage: gameImages.zwepz,
    route: 'zwepz',
    color: 'from-amber-600 to-yellow-500',
    category: 'arcade',
    players: 56,
    prizePool: '1,800 CRD',
    isNew: true,
  },
  {
    id: 'hype-crash',
    title: 'HYPE CRASH',
    subtitle: 'Trade',
    description: 'Watch the hype multiplier climb. Cash out before it crashes.',
    icon: <TrendingUp size={24} />,
    bgImage: gameImages.crash,
    route: 'hype-crash',
    color: 'from-red-600 to-pink-500',
    category: 'arcade',
    players: 92,
    prizePool: '6,500 CRD',
    isLive: true,
    isHot: true,
  },
  {
    id: 'hype-sweeper',
    title: 'HYPE SWEEPER',
    subtitle: 'Clear Grid',
    description: 'Minesweeper with a hype twist. Clear the grid without hitting mines.',
    icon: <Target size={24} />,
    bgImage: gameImages.sweeper,
    route: 'hype-sweeper',
    color: 'from-gray-700 to-zinc-600',
    category: 'strategy',
    players: 28,
    prizePool: '1,200 CRD',
  },
  {
    id: 'shells',
    title: 'SHELLS',
    subtitle: 'Survive',
    description: 'Find the prize under the moving shells. Quick eyes and steady hands win.',
    icon: <Crosshair size={24} />,
    bgImage: gameImages.shells,
    route: 'shells',
    color: 'from-emerald-600 to-green-500',
    category: 'arcade',
    players: 41,
    prizePool: '2,000 CRD',
  },
];

// 🟢 LIVE WINS
const NAMES = ['CryptoKing', 'SneakerHead', 'StreetWear', 'HypeBeast', 'UrbanFit', 'FashionGod', 'ThreadMaster', 'StyleNinja', 'VibeLord', 'FitKing', 'DripQueen', 'SoleCollector'];

const getRandomName = () => NAMES[Math.floor(Math.random() * NAMES.length)];
const getRandomGame = () => GAMES[Math.floor(Math.random() * GAMES.length)];
const getRandomPrize = () => {
  const prizes = [
    '500 CRD', '1,000 CRD', '2,500 CRD', '5,000 CRD', 'Scoop Hoodie', 
    'Exclusive Tee', 'Vintage Cap', 'Streetwear Jacket', 'Limited Sneakers',
    '10,000 CRD', 'Mystery Box', 'Free Shipping Voucher', '50% Off Voucher'
  ];
  return prizes[Math.floor(Math.random() * prizes.length)];
};

interface LiveWin {
  id: string;
  game: string;
  user: string;
  prize: string;
  image: string;
}

// ============================================================================
// PARTICLE BACKGROUND COMPONENT
// ============================================================================
const ParticleBackground = () => (
  <div className="fixed inset-0 pointer-events-none z-0">
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-blue-900/20 via-transparent to-transparent" />
    {[...Array(30)].map((_, i) => (
      <div
        key={i}
        className="absolute w-1 h-1 bg-blue-400/20 rounded-full animate-pulse"
        style={{
          top: `${Math.random() * 100}%`,
          left: `${Math.random() * 100}%`,
          animationDelay: `${Math.random() * 4}s`,
          animationDuration: `${2 + Math.random() * 4}s`,
          width: `${Math.random() * 3 + 1}px`,
          height: `${Math.random() * 3 + 1}px`,
        }}
      />
    ))}
  </div>
);

// ============================================================================
// MAIN HYPE ARCADE VIEW
// ============================================================================

interface HypeArcadeViewProps {
  onOpenMysteryDrop?: () => void;
  onOpenHyce?: () => void;
  onOpenCopOrDrop?: () => void;
  onOpenHypeStacker?: () => void;
  onOpenBallDrop?: () => void;
  onOpenGlassBridge?: () => void;
  onOpenZwepz?: () => void;
}

export const HypeArcadeView: React.FC<HypeArcadeViewProps> = ({
  onOpenMysteryDrop,
  onOpenHyce,
  onOpenCopOrDrop,
  onOpenHypeStacker,
  onOpenBallDrop,
  onOpenGlassBridge,
  onOpenZwepz,
}) => {
  const navigate = useNavigate();
  const { user: currentUser, profile: userProfile, updateProfile } = useAuth();
  const { cartItems } = useCart();
  const [activeCategory, setActiveCategory] = useState('All');
  const [isLoading, setIsLoading] = useState(false);
  const [liveWins, setLiveWins] = useState<LiveWin[]>([]);
  const [realProducts, setRealProducts] = useState<any[]>([]);
  const [isWalletOpen, setIsWalletOpen] = useState(false);
  const [hoveredGame, setHoveredGame] = useState<string | null>(null);

  const cartCount = cartItems?.length || 0;

  // 🟢 FETCH REAL PRODUCTS FOR LIVE DROPS
  useEffect(() => {
    const fetchProducts = async () => {
      setIsLoading(true);
      try {
        const q = query(collection(db, 'products'), limit(20));
        const snapshot = await getDocs(q);
        const products = snapshot.docs.map(doc => {
          const data = doc.data();
          return {
            id: doc.id,
            image: data.image || data.images?.[0] || 'https://images.unsplash.com/photo-1556905055-8f358a7a47b2?w=100&h=100&fit=crop&crop=center',
            name: data.name || 'Product',
          };
        });
        setRealProducts(products);
      } catch (error) {
        console.error("Failed to load products for Live Drops:", error);
        const fallbackProducts = [
          { id: 'f1', image: 'https://images.unsplash.com/photo-1556905055-8f358a7a47b2?w=100&h=100&fit=crop&crop=center', name: 'Streetwear Hoodie' },
          { id: 'f2', image: 'https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=100&h=100&fit=crop&crop=center', name: 'Vintage Tee' },
          { id: 'f3', image: 'https://images.unsplash.com/photo-1532453288672-3a27e9be9efd?w=100&h=100&fit=crop&crop=center', name: 'Sneakers' },
        ];
        setRealProducts(fallbackProducts);
      } finally {
        setIsLoading(false);
      }
    };
    fetchProducts();
  }, []);

  // 🟢 GENERATE LIVE WINS with real product images
  useEffect(() => {
    if (realProducts.length === 0) return;
    
    const generateWins = () => {
      const wins = Array.from({ length: 20 }).map((_, i) => {
        const randomProduct = realProducts[Math.floor(Math.random() * realProducts.length)];
        return {
          id: `w${i}`,
          game: getRandomGame().title,
          user: getRandomName(),
          prize: getRandomPrize(),
          image: randomProduct.image,
        };
      });
      setLiveWins(wins);
    };
    
    generateWins();
    
    const interval = setInterval(() => {
      const randomProduct = realProducts[Math.floor(Math.random() * realProducts.length)];
      const newWin: LiveWin = {
        id: `w${Date.now()}`,
        game: getRandomGame().title,
        user: getRandomName(),
        prize: getRandomPrize(),
        image: randomProduct.image,
      };
      setLiveWins(prev => [newWin, ...prev.slice(0, 19)]);
    }, 3000);
    
    return () => clearInterval(interval);
  }, [realProducts]);

  // 🟢 FORMAT CREDITS
  const formatCredits = (amount: number) => {
    if (amount >= 1e42) return '∞';
    if (amount >= 1e9) return (amount / 1e9).toFixed(1) + 'B';
    if (amount >= 1e6) return (amount / 1e6).toFixed(1) + 'M';
    if (amount >= 1e3) return (amount / 1e3).toFixed(1) + 'K';
    return amount.toString();
  };

  // 🟢 GAME ROUTE HANDLER
  const handleGameClick = (game: Game) => {
    switch (game.id) {
      case 'thread-wars':
        window.dispatchEvent(new Event('open-thread-game'));
        break;
      case 'cop-or-drop':
        if (onOpenCopOrDrop) onOpenCopOrDrop();
        break;
      case 'mystery-drop':
        if (onOpenMysteryDrop) onOpenMysteryDrop();
        break;
      case 'hyce':
        if (onOpenHyce) onOpenHyce();
        break;
      case 'hype-stacker':
        if (onOpenHypeStacker) onOpenHypeStacker();
        break;
      case 'ball-drop':
        if (onOpenBallDrop) onOpenBallDrop();
        break;
      case 'glass-bridge':
        if (onOpenGlassBridge) onOpenGlassBridge();
        break;
      case 'zwepz':
        if (onOpenZwepz) onOpenZwepz();
        break;
      case 'hype-crash':
        window.dispatchEvent(new Event('open-hype-crash'));
        break;
      case 'hype-sweeper':
        window.dispatchEvent(new Event('open-hype-mines'));
        break;
      case 'shells':
        window.dispatchEvent(new Event('open-hype-shells'));
        break;
      default:
        break;
    }
  };

  // 🟢 FILTER GAMES
  const filteredGames = GAMES.filter(game => {
    if (activeCategory === 'All') return true;
    return game.category === activeCategory.toLowerCase();
  });

  // 🟢 CATEGORIES WITH ICONS
  const categories = [
    { name: 'All', icon: null },
    { name: 'Arcade', icon: Gamepad2 },
    { name: 'Strategy', icon: Target },
    { name: 'Social', icon: Users },
  ];

  // 🟢 CRD BALANCE
  const balance = userProfile?.cred || 0;

  // 🟢 HANDLE DEPOSIT - Opens WalletTerminal
  const handleDeposit = () => {
    if (!currentUser) {
      window.dispatchEvent(new CustomEvent('open-login-modal'));
      return;
    }
    setIsWalletOpen(true);
  };

  // 🟢 SKELETON LOADER
  const SkeletonCard = () => (
    <div className="aspect-square rounded-xl bg-white/5 backdrop-blur-xl border border-white/10 animate-pulse">
      <div className="w-full h-full bg-gradient-to-br from-white/5 to-white/10 rounded-xl" />
    </div>
  );

  // 🟢 NAV LINKS FOR HEADER
  const navLinks = ['Brands', 'Jewellery', 'Thrift', 'Games', 'Designer'];
  
  const getNavPath = (link: string) => {
    if (link === 'Brands') return '/';
    if (link === 'Jewellery') return '/jewellery';
    if (link === 'Thrift') return '/thrifts';
    if (link === 'Games') return '/games';
    if (link === 'Designer') return '/designer';
    return '/';
  };

  return (
    <div className="min-h-screen bg-black text-white font-sans pb-24 relative">
      
      {/* 🟢 PARTICLE BACKGROUND */}
      <ParticleBackground />

      {/* 🟢 WALLET TERMINAL MODAL */}
      <WalletTerminal
        isOpen={isWalletOpen}
        onClose={() => setIsWalletOpen(false)}
        currentUser={currentUser}
      />

      {/* Blue glow background */}
      <div className="fixed inset-0 pointer-events-none z-0">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-600/10 blur-[150px] rounded-full" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-blue-400/5 blur-[150px] rounded-full" />
      </div>

      {/* =========================================================================
          🖥️ DESKTOP HEADER
      ========================================================================= */}
      <header className="hidden lg:flex fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-xl border-b border-white/10 flex-col">
        <div className="flex justify-between items-center py-2 px-8 border-b border-white/5 text-[10px] uppercase tracking-widest font-bold text-zinc-500">
          <span className="flex items-center gap-2">
            <div className="w-1.5 h-1.5 rounded-full bg-blue-400 animate-pulse" />
            Hype Arcade
          </span>
          <span className="bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">Play. Win. Dominate.</span>
        </div>

        <div className="flex items-center justify-between h-20 px-8">
          <nav className="flex gap-6 items-center">
            {navLinks.map((link) => {
              const path = getNavPath(link);
              return (
                <NavLink 
                  key={link} 
                  to={path}
                  className={({isActive}) => `text-xs font-black uppercase tracking-[0.2em] hover:text-white transition-all duration-300 whitespace-nowrap relative ${isActive ? 'text-white' : 'text-zinc-500 hover:text-zinc-300'}`}
                >
                  {({isActive}) => (
                    <>
                      {link}
                      {isActive && (
                        <span className="absolute -bottom-1 left-0 right-0 h-0.5 bg-gradient-to-r from-blue-400 to-purple-400 rounded-full shadow-[0_0_10px_rgba(59,130,246,0.5)]" />
                      )}
                    </>
                  )}
                </NavLink>
              );
            })}
          </nav>

          <div className="absolute left-1/2 -translate-x-1/2 flex items-center gap-2 cursor-pointer group" onClick={() => navigate('/')}>
            <h1 className="text-3xl font-black italic tracking-tighter bg-gradient-to-r from-white via-blue-300 to-purple-400 bg-clip-text text-transparent group-hover:scale-105 transition-transform duration-300">
              HYPEARCADE
            </h1>
          </div>

          <div className="flex items-center gap-6">
            <NavLink to="/search" className="text-zinc-500 hover:text-white transition-colors duration-300" title="Search">
              <Search size={20} />
            </NavLink>
            
            <button onClick={() => window.dispatchEvent(new CustomEvent('open-messages'))} className="text-zinc-500 hover:text-white transition-colors duration-300 relative" title="Messages">
              <MessageCircle size={20} />
            </button>

            <button onClick={() => window.dispatchEvent(new CustomEvent('open-notifications'))} className="text-zinc-500 hover:text-white transition-colors duration-300 relative" title="Notifications">
              <Bell size={20} />
            </button>

            <button onClick={() => window.dispatchEvent(new CustomEvent('open-creation-menu'))} className="flex items-center gap-2 text-zinc-500 hover:text-white transition-colors duration-300" title="Create Post">
              <Plus size={20} strokeWidth={2} />
            </button>

            <NavLink to="/profile" className="text-xs font-black uppercase tracking-widest text-zinc-500 hover:text-white transition-colors duration-300 flex items-center gap-2">
              <div className="w-6 h-6 rounded-full bg-zinc-800 flex items-center justify-center">
                <User size={12} className="text-zinc-400" />
              </div>
              {currentUser ? formatCredits(balance) : 'Login'}
            </NavLink>
            
            <button onClick={() => window.dispatchEvent(new CustomEvent('open-cart'))} className={`flex items-center gap-2 transition-all duration-300 ${cartCount > 0 ? 'text-white' : 'text-zinc-500 hover:text-white'}`}>
              <ShoppingBag size={20} />
              <span className="text-xs font-black">({cartCount})</span>
            </button>
          </div>
        </div>
      </header>

      {/* =========================================================================
          📱 MOBILE HEADER
      ========================================================================= */}
      <header className="lg:hidden sticky top-0 z-40 bg-black/80 backdrop-blur-xl border-b border-white/10">
        <div className="flex items-center justify-between px-4 py-3">
          <div className="flex items-center gap-2 cursor-pointer group" onClick={() => navigate('/')}>
            <h1 className="text-xl font-black italic tracking-tighter bg-gradient-to-r from-white to-blue-400 bg-clip-text text-transparent">
              HYPEARCADE
            </h1>
          </div>
          
          <div className="flex gap-4 items-center text-zinc-300">
            <button onClick={() => window.dispatchEvent(new CustomEvent('open-messages'))} className="hover:text-white transition-colors relative">
              <MessageCircle size={20} />
            </button>
            <button onClick={() => window.dispatchEvent(new CustomEvent('open-notifications'))} className="hover:text-white transition-colors relative">
              <Bell size={20} />
            </button>
            <button onClick={() => window.dispatchEvent(new CustomEvent('open-cart'))} className="hover:text-white transition-colors relative">
              <ShoppingBag size={20} />
              {cartCount > 0 && (
                <span className="absolute -top-2 -right-2 bg-white text-black text-[8px] font-bold w-4 h-4 rounded-full flex items-center justify-center">
                  {cartCount}
                </span>
              )}
            </button>
          </div>
        </div>

        <div className="flex justify-between items-center px-4 pb-1 border-b border-white/5 relative">
          {navLinks.map((tab) => {
            const path = getNavPath(tab);
            const isGamesTab = tab === 'Games';
            
            return (
              <NavLink
                key={tab}
                to={path}
                className={({isActive}) => {
                  const active = isActive || isGamesTab;
                  return `flex-1 text-center py-2.5 text-[10px] font-black uppercase tracking-wider transition-all duration-200 relative ${
                    active ? 'text-white' : 'text-zinc-500 hover:text-zinc-300'
                  }`;
                }}
              >
                {({isActive}) => {
                  const active = isActive || isGamesTab;
                  return (
                    <>
                      {tab}
                      {active && (
                        <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-1/2 h-0.5 bg-gradient-to-r from-blue-400 to-purple-400 rounded-full shadow-[0_0_10px_rgba(59,130,246,0.5)]" />
                      )}
                    </>
                  );
                }}
              </NavLink>
            );
          })}
        </div>
      </header>

      {/* =========================================================================
          MAIN CONTENT
      ========================================================================= */}
      <div className="relative z-10 lg:pt-[105px] pt-0">
        
        {/* ======================================================================
            PRIZE POOL BANNER - ENHANCED
            ====================================================================== */}
        <div className="px-4 py-4">
          <div className="relative group">
            <div className="absolute -inset-0.5 bg-gradient-to-r from-blue-600 via-purple-600 to-blue-600 rounded-xl blur opacity-30 group-hover:opacity-60 transition duration-1000 group-hover:duration-200 animate-gradient" />
            
            <div className="relative bg-gradient-to-br from-blue-900/50 via-blue-950/30 to-black rounded-xl p-4 overflow-hidden shadow-[0_0_40px_rgba(59,130,246,0.15)]">
              <div className="absolute -top-4 -right-4 w-24 h-24 bg-blue-500/20 blur-2xl rounded-full pointer-events-none" />
              <div className="absolute -bottom-8 -left-8 w-32 h-32 bg-blue-400/10 blur-2xl rounded-full pointer-events-none" />
              
              {/* Animated shimmer */}
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 pointer-events-none" />
              
              <div className="text-center mb-3 relative z-10">
                <h2 className="text-sm font-black text-white uppercase tracking-wider drop-shadow-[0_0_20px_rgba(255,255,255,0.1)] flex items-center justify-center gap-2">
                  <Trophy size={16} className="text-yellow-400" />
                  Win Your Favourite Pieces
                </h2>
              </div>

              <div className="grid grid-cols-2 gap-3 relative z-10">
                <div className="bg-black/40 backdrop-blur-sm rounded-lg overflow-hidden border border-blue-500/20 hover:border-blue-400/40 transition-all duration-300 group cursor-pointer hover:scale-[1.02] transform">
                  <div className="relative h-20 overflow-hidden">
                    <img src={prizeImages.merch} alt="Free Merch" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
                  </div>
                  <div className="p-2 text-center">
                    <div className="flex items-center justify-center gap-1.5">
                      <Gift size={14} className="text-blue-400" />
                      <span className="text-[10px] font-black text-white uppercase tracking-wider">Win Free Drip</span>
                    </div>
                    <p className="text-[7px] text-blue-300/60 uppercase tracking-widest mt-0.5">Exclusive streetwear</p>
                  </div>
                </div>

                <div className="bg-black/40 backdrop-blur-sm rounded-lg overflow-hidden border border-blue-500/20 hover:border-blue-400/40 transition-all duration-300 group cursor-pointer hover:scale-[1.02] transform">
                  <div className="relative h-20 overflow-hidden">
                    <img src={prizeImages.jackpot} alt="Credit Jackpot" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
                  </div>
                  <div className="p-2 text-center">
                    <div className="flex items-center justify-center gap-1.5">
                      <Coins size={14} className="text-yellow-400" />
                      <span className="text-[10px] font-black text-white uppercase tracking-wider">Win Credit Jackpot</span>
                    </div>
                    <p className="text-[7px] text-yellow-300/60 uppercase tracking-widest mt-0.5">Up to 50,000 CRD</p>
                  </div>
                </div>
              </div>

              <div className="absolute top-3 right-3 bg-black/50 backdrop-blur-xl text-blue-400 text-[9px] font-bold px-2.5 py-1 rounded border border-blue-500/30 shadow-[0_0_10px_rgba(59,130,246,0.2)] z-10 flex items-center gap-1">
                <Clock size={10} />
                1d
              </div>
            </div>
          </div>
        </div>

        {/* ======================================================================
            "NEED CREDITS?" SECTION - PREMIUM VERSION
            ====================================================================== */}
        <div className="px-4 pb-4">
          <div className="relative group">
            <div className="absolute -inset-0.5 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 rounded-xl blur opacity-20 group-hover:opacity-40 transition duration-500" />
            
            <div className="relative bg-gradient-to-br from-gray-900/80 via-gray-800/80 to-blue-900/80 backdrop-blur-xl border border-white/10 rounded-xl p-6 shadow-2xl">
              <div className="absolute top-0 right-0 w-32 h-32 bg-blue-500/10 rounded-full blur-3xl animate-pulse pointer-events-none" />
              <div className="absolute bottom-0 left-0 w-32 h-32 bg-purple-500/10 rounded-full blur-3xl animate-pulse pointer-events-none" />
              
              <div className="text-center mb-5 relative z-10">
                <div className="inline-flex items-center gap-3 bg-white/5 backdrop-blur-sm border border-white/10 rounded-full px-4 py-2 mb-3">
                  <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center shadow-lg shadow-blue-500/25">
                    <Coins size={16} className="text-white" />
                  </div>
                  <div>
                    <p className="text-[10px] text-white/50 font-medium">Available Balance</p>
                    <p className="text-lg font-bold text-white">{formatCredits(balance)} <span className="text-xs text-blue-400 font-medium">CRD</span></p>
                  </div>
                </div>
                
                <h3 className="text-xl font-bold bg-gradient-to-r from-white to-blue-200 bg-clip-text text-transparent">
                  Need More Credits?
                </h3>
              </div>

              <div className="grid grid-cols-3 gap-3 mb-4 relative z-10">
                {[
                  { name: 'Mastercard', key: 'mastercard' },
                  { name: 'Apple Pay', key: 'applepay' },
                  { name: 'Visa', key: 'visa' }
                ].map((method) => (
                  <div 
                    key={method.name}
                    className="bg-white/5 backdrop-blur-sm rounded-lg p-3 border border-white/5 hover:border-blue-500/30 transition-all cursor-pointer group hover:bg-white/10 hover:scale-105 transform duration-300"
                  >
                    <div className="flex items-center justify-center h-8">
                      <img 
                        src={paymentIcons[method.key as keyof typeof paymentIcons]}
                        alt={method.name}
                        className="h-6 object-contain opacity-70 group-hover:opacity-100 transition-opacity"
                      />
                    </div>
                    <p className="text-[7px] text-center text-white/30 group-hover:text-white/60 transition-colors mt-1 font-medium uppercase tracking-wider">
                      {method.name}
                    </p>
                  </div>
                ))}
              </div>

              <button 
                onClick={handleDeposit}
                className="w-full relative overflow-hidden group bg-gradient-to-r from-blue-600 via-purple-600 to-blue-600 hover:from-blue-500 hover:via-purple-500 hover:to-blue-500 text-white font-bold py-3.5 rounded-xl flex items-center justify-center gap-3 transition-all duration-300 shadow-lg shadow-blue-500/25 hover:shadow-blue-500/40 relative z-10"
              >
                <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700" />
                <CreditCard size={18} />
                <span>Buy Credits</span>
              </button>
            </div>
          </div>
        </div>

        {/* ======================================================================
            LIVE DROPS - ENHANCED
            ====================================================================== */}
        <div className="px-4 pb-4">
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-3">
              <div className="relative">
                <div className="w-2 h-2 rounded-full bg-cyan-400 animate-pulse shadow-[0_0_20px_rgba(34,211,238,0.8)]" />
                <div className="absolute inset-0 w-2 h-2 rounded-full bg-cyan-400 animate-ping opacity-75" />
              </div>
              <h3 className="text-xs font-black text-cyan-400 uppercase tracking-[0.2em]">Live Drops</h3>
              <span className="text-[8px] text-white/30 font-mono">• real-time wins</span>
            </div>
            <span className="text-[8px] text-white/20 font-mono animate-pulse">●●●</span>
          </div>
          
          <div className="relative overflow-hidden bg-white/5 backdrop-blur-xl border border-white/10 rounded-xl py-3 shadow-inner">
            <div className="flex animate-marquee whitespace-nowrap gap-8">
              {liveWins.map((win, index) => (
                <div key={win.id + index} className="flex items-center gap-3 px-3 py-1.5 rounded-lg bg-white/5 backdrop-blur-sm border border-white/5 hover:border-cyan-500/30 transition-all group">
                  <div className="relative w-10 h-10 rounded-lg bg-black border border-cyan-500/30 overflow-hidden shrink-0 flex items-center justify-center shadow-inner">
                    <img src={win.image} alt={win.prize} className="w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
                  </div>
                  <div className="text-left">
                    <p className="text-white/50 text-[7px] font-bold uppercase tracking-widest group-hover:text-white/70 transition-colors">{win.user}</p>
                    <p className="text-white font-bold text-[10px] truncate max-w-[80px] group-hover:text-cyan-300 transition-colors">{win.prize}</p>
                  </div>
                  <div className="text-left">
                    <p className="text-cyan-400 font-bold text-[8px]">{win.game}</p>
                    <p className="text-white/30 text-[6px] font-mono uppercase">Just now</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ======================================================================
            CATEGORY FILTER - ENHANCED
            ====================================================================== */}
        <div className="px-4 pb-4">
          <div className="flex gap-2 overflow-x-auto scrollbar-hide pb-1">
            {categories.map((cat) => {
              const Icon = cat.icon;
              const isActive = activeCategory === cat.name;
              return (
                <button
                  key={cat.name}
                  onClick={() => setActiveCategory(cat.name)}
                  className={`shrink-0 px-4 py-2 text-[10px] font-black uppercase tracking-widest transition-all duration-300 border rounded-full flex items-center gap-2 ${
                    isActive
                      ? 'bg-gradient-to-r from-blue-500 to-purple-500 text-white border-transparent shadow-[0_0_30px_rgba(59,130,246,0.3)] scale-105'
                      : 'bg-white/5 backdrop-blur-sm text-white/60 border-white/10 hover:border-blue-500/30 hover:text-white/80 hover:scale-105'
                  }`}
                >
                  {Icon && <Icon size={14} className={isActive ? 'text-white' : 'text-white/60'} />}
                  {cat.name}
                </button>
              );
            })}
          </div>
        </div>

        {/* ======================================================================
            GAME CARDS - ENHANCED WITH HOVER EFFECTS
            ====================================================================== */}
        <div className="px-4 pb-8">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
            {isLoading ? (
              [...Array(8)].map((_, i) => <SkeletonCard key={i} />)
            ) : (
              filteredGames.map((game) => (
                <div 
                  key={game.id}
                  onClick={() => handleGameClick(game)}
                  onMouseEnter={() => setHoveredGame(game.id)}
                  onMouseLeave={() => setHoveredGame(null)}
                  className="relative aspect-square rounded-xl overflow-hidden cursor-pointer group transform transition-all duration-500 hover:-translate-y-1 hover:scale-[1.02]"
                >
                  {/* Glowing border on hover */}
                  <div className={`absolute -inset-0.5 bg-gradient-to-r from-blue-500/0 via-blue-500/20 to-blue-500/0 rounded-xl transition-opacity duration-500 ${hoveredGame === game.id ? 'opacity-100' : 'opacity-0'}`} />
                  
                  <div className="relative w-full h-full bg-white/5 backdrop-blur-xl border border-white/10 rounded-xl overflow-hidden shadow-lg group-hover:shadow-2xl transition-all duration-500">
                    <img 
                      src={game.bgImage} 
                      className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" 
                      alt={game.title} 
                    />
                    
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
                    
                    <div className={`absolute inset-0 transition-opacity duration-500 ${hoveredGame === game.id ? 'opacity-100' : 'opacity-0'}`}>
                      <div className="absolute inset-0 bg-blue-500/10 blur-xl" />
                    </div>
                    
                    <div className="relative z-10 p-2 flex flex-col h-full">
                      <div className="flex items-start justify-between">
                        <div className="flex items-center gap-1">
                          {game.isLive && (
                            <span className="flex items-center gap-1 px-1.5 py-0.5 bg-gradient-to-r from-red-500 to-red-600 text-white text-[6px] font-black uppercase tracking-widest rounded shadow-[0_0_10px_rgba(239,68,68,0.3)] animate-pulse">
                              <span className="w-1 h-1 rounded-full bg-white animate-pulse" />
                              LIVE
                            </span>
                          )}
                          {game.isHot && (
                            <span className="px-1.5 py-0.5 bg-gradient-to-r from-orange-500 to-orange-600 text-white text-[6px] font-black uppercase tracking-widest rounded flex items-center gap-1 shadow-[0_0_10px_rgba(251,146,60,0.3)]">
                              <Flame size={8} /> HOT
                            </span>
                          )}
                          {game.isNew && (
                            <span className="px-1.5 py-0.5 bg-gradient-to-r from-green-500 to-green-600 text-white text-[6px] font-black uppercase tracking-widest rounded shadow-[0_0_10px_rgba(34,197,94,0.3)]">
                              NEW
                            </span>
                          )}
                        </div>
                        <div className="flex items-center gap-1 text-white/60 text-[6px] font-black uppercase tracking-widest">
                          <Users size={10} />
                          {game.players}
                        </div>
                      </div>

                      <div className="flex-1" />

                      <div className="text-center">
                        <h3 className="text-xs lg:text-sm font-black text-white tracking-tight drop-shadow-[0_0_10px_rgba(255,255,255,0.1)]">
                          {game.title}
                        </h3>
                        <p className="text-[7px] lg:text-[8px] font-bold uppercase tracking-widest text-white/60 mt-0.5">
                          {game.subtitle}
                        </p>
                      </div>

                      <div className="flex items-center justify-between mt-2 pt-1.5 border-t border-white/10">
                        {game.prizePool ? (
                          <div className="flex items-center gap-1">
                            <Trophy size={10} className="text-yellow-400" />
                            <span className="text-[7px] lg:text-[8px] font-bold text-white">{game.prizePool}</span>
                          </div>
                        ) : (
                          <div />
                        )}
                        <span className={`text-[7px] lg:text-[8px] font-black uppercase tracking-widest transition-colors flex items-center gap-1 ${hoveredGame === game.id ? 'text-blue-400' : 'text-white/50'}`}>
                          Play <ChevronRight size={10} className={`transition-transform duration-300 ${hoveredGame === game.id ? 'translate-x-1' : ''}`} />
                        </span>
                      </div>
                    </div>

                    {/* Progress bar on hover */}
                    <div className={`absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 transform origin-left transition-transform duration-700 ${hoveredGame === game.id ? 'scale-x-100' : 'scale-x-0'}`} />
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          display: inline-flex;
          animation: marquee 25s linear infinite;
        }
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }

        @keyframes gradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        .animate-gradient {
          background-size: 200% 200%;
          animation: gradient 3s ease infinite;
        }

        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
        .animate-float {
          animation: float 6s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default HypeArcadeView;